import '@zillow/cosmos/dist/styles.css';
import '@zillow/constellation-fonts/zillow-fonts.css';
import './index.css';

import { renderClientIndex } from '@zg-rentals/rental-manager-env';
import App from './App';
import { getClient } from '@zg-rentals/ts-client-http-client';
import { setClient as setLeasingClient } from '@zg-rentals/ts-leasing-client/client';
import { setClient as setRinsClient } from '@zg-rentals/ts-rins-client/client';
import { setClient as setRentalManagerClient } from '@zg-rentals/ts-rental-manager-api-client/client';
import { getBooleanConfig } from '@zg-rentals/frontend-config/client';
import { analytics } from './analytics';
import { rentalManagerClient } from './rentalManagerClient';

renderClientIndex({
  app: <App />,
  appName: __APP_NAME__,
  onBootstrapRegister: analytics.initialize,
});

// Set Panda CSS theme for Constellation v10 visual refresh
const isVisualRefreshEnabled = getBooleanConfig('isVisualRefreshEnabled', false);
document.documentElement.setAttribute('data-panda-theme', isVisualRefreshEnabled ? 'zillow' : 'legacy-zillow');

module.hot?.accept();

setLeasingClient(
  getClient().extend({
    prefixUrl: __DEV__ ? (__API__.includes('localhost') ? __API__ : `${__API__}rental`) : '/rental',
  }),
);

setRinsClient(
  getClient().extend({
    prefixUrl: __DEV__ ? (__API__.includes('localhost') ? __API__ : `${__API__}rental`) : '/rental',
  }),
);

setRentalManagerClient(rentalManagerClient);
